module.exports = __webpack_public_path__ + "static/Pianeta_new_ats_7-b80b8b44ec526e9862d0eeaa26ae8bb5.svg";